<template>
  <div
    ref="tooltipElement"
    class="tooltip-tag"
    :class="{ 'tooltip-tag--max-width': hasMaxWidth }"
    data-bs-toggle="tooltip"
    :data-bs-title="
      hasMaxWidth === true
        ? name + '<br><strong>Klik om te verwijderen</strong>'
        : 'Klik om te verwijderen'
    "
    :data-bs-html="hasMaxWidth"
    data-bs-placement="bottom"
    data-bs-trigger="hover"
    data-bs-delay="0"
    @click="handleRemove"
  >
    <span class="name">{{ name }}</span>
    <span class="remove">
      <i class="icon icon-close"></i>
    </span>
  </div>
</template>

<script>
import { Tooltip } from 'bootstrap';

export default {
  name: 'TooltipTag',
  props: {
    name: {
      type: String,
      required: true,
    },
    hasMaxWidth: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['remove'],
  data() {
    return {
      tooltip: null,
    };
  },
  mounted() {
    this.initializeTooltip();
  },
  beforeUnmount() {
    this.destroyTooltip();
  },
  unmounted() {
    this.destroyTooltip();
  },
  watch: {
    name: {
      handler() {
        this.destroyTooltip();
        this.$nextTick(() => {
          this.initializeTooltip();
        });
      },
    },
  },
  methods: {
    initializeTooltip() {
      if (this.$refs.tooltipElement) {
        this.tooltip = new Tooltip(this.$refs.tooltipElement);
      }
    },
    destroyTooltip() {
      if (this.tooltip) {
        try {
          this.tooltip.dispose();
        } catch (error) {}
        this.tooltip = null;
      }

      const tooltipElements = document.querySelectorAll('.tooltip');
      tooltipElements.forEach((tooltip) => {
        tooltip.style.display = 'none';
      });
    },
    handleRemove() {
      this.destroyTooltip();

      const tooltipElements = document.querySelectorAll('.tooltip');
      tooltipElements.forEach((tooltip) => {
        if (tooltip.style.display !== 'none') {
          tooltip.style.display = 'none';
        }
      });

      this.$emit('remove');
    },
  },
};
</script>

<style scoped></style>
